import { render, staticRenderFns } from "./PromotionalVideosView.vue?vue&type=template&id=8f9b45ba&scoped=true"
import script from "./PromotionalVideosView.vue?vue&type=script&lang=js"
export * from "./PromotionalVideosView.vue?vue&type=script&lang=js"
import style0 from "./PromotionalVideosView.vue?vue&type=style&index=0&id=8f9b45ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9b45ba",
  null
  
)

export default component.exports